<ol class="park-steps">
  <li *ngFor="let step of steps; let last = last" class="park-step"
      [class.active]="step.id === current"
      [class.clickable]="canGo(step)"
      (click)="onClick(step)">
    <span class="park-step-dot">{{ step.id }}</span>
    <span class="park-step-label">
      <span class="park-step-pre">{{ step.pre }}</span>
      <strong>{{ step.strong }}</strong>
    </span>
    <span *ngIf="!last" class="park-step-line"></span>
  </li>
</ol>
